import { slug, splitLines } from '../detect.js';
const SHAPE_MAP = {
    person: 'person',
    system: 'rect',
    systemDb: 'cylinder',
    systemQueue: 'queue',
    systemBoundary: 'rect',
    container: 'rect',
    containerDb: 'cylinder',
    containerQueue: 'queue',
    containerBoundary: 'rect',
    component: 'rect',
    componentDb: 'cylinder',
    componentQueue: 'queue',
    node: 'rect',
    deploymentNode: 'rect',
};
const RELATION_RE = /^\s*(Rel|Rel_Back|BiRel|BiRel_Back)\s*\(\s*([A-Za-z_][\w-]*)\s*,\s*([A-Za-z_][\w-]*)\s*(?:,\s*"((?:[^"\\]|\\.)*)")?\s*(?:,\s*"((?:[^"\\]|\\.)*)")?\s*\)\s*(?:,\s*"((?:[^"\\]|\\.)*)")?\s*$/;
const lineForKind = (kind) => {
    // Matches: Kind(id [, "label" [, "description" [, $sprite]]])  OR  Kind(id, "label" $tags="...")  OR  Kind(id)
    const pattern = `^\\s*${kind}(?:Db|Queue|Boundary)?\\s*\\(\\s*([A-Za-z_][\\w-]*)\\s*(?:,\\s*"((?:[^"\\\\]|\\\\.)*)")?(?:\\s*,\\s*"((?:[^"\\\\]|\\\\.)*)")?(?:\\s*,\\s*\\$[A-Za-z_][\\w-]*)?\\s*\\)\\s*$`;
    return new RegExp(pattern, 'i');
};
const BOUNDARY_OPEN_RE = /^\s*Boundary\((\S+?)\s*,\s*"([^"]+)"\)\s*\{?\s*$/;
const ENTERPRISE_RE = /^\s*Enterprise(?:_?Boundary)?\s*(\S+?)?\s*(?:,\s*"([^"]+)")?\s*\{?\s*$/;
export const parseC4 = (source, type) => {
    const lines = splitLines(source);
    const nodes = new Map();
    const edges = [];
    const groups = [];
    const stack = [];
    const tierForKind = (kind) => {
        if (kind.startsWith('person'))
            return 'person';
        if (kind.startsWith('system'))
            return 'system';
        if (kind.startsWith('container'))
            return 'container';
        if (kind.startsWith('component'))
            return 'component';
        if (kind === 'deploymentNode' || kind === 'node')
            return 'node';
        return 'default';
    };
    const ensure = (id, label, shape, kind) => {
        if (!nodes.has(id)) {
            const tier = kind ? tierForKind(kind) : 'default';
            nodes.set(id, { id, label, shape, parent: stack[stack.length - 1], layer: tier, meta: { tier } });
        }
    };
    const kinds = [
        'person',
        'system',
        'systemDb',
        'systemQueue',
        'systemBoundary',
        'container',
        'containerDb',
        'containerQueue',
        'containerBoundary',
        'component',
        'componentDb',
        'componentQueue',
        'deploymentNode',
    ];
    for (const raw of lines) {
        const line = raw.trim();
        if (!line || new RegExp(`^${type}\\b`, 'i').test(line))
            continue;
        // Boundary open
        const eb = ENTERPRISE_RE.exec(line);
        if (eb) {
            const id = `b_${slug(eb[1] ?? 'enterprise')}`;
            stack.push(id);
            groups.push({ id, label: eb[2] ?? 'Enterprise', members: [], parent: stack[stack.length - 2] });
            continue;
        }
        const bn = BOUNDARY_OPEN_RE.exec(line);
        if (bn) {
            const id = `b_${slug(bn[1] ?? `boundary_${groups.length}`)}`;
            stack.push(id);
            groups.push({ id, label: bn[2] ?? bn[1] ?? 'Boundary', members: [], parent: stack[stack.length - 2] });
            continue;
        }
        if (line === '}') {
            stack.pop();
            continue;
        }
        const rel = RELATION_RE.exec(line);
        if (rel) {
            const [, , from, to, label] = rel;
            edges.push({
                id: `e_${edges.length}_${from}_${to}`,
                from: from,
                to: to,
                label,
            });
            ensure(from, from, 'rect');
            ensure(to, to, 'rect');
            continue;
        }
        for (const k of kinds) {
            const re = lineForKind(k);
            const m = re.exec(line);
            if (m) {
                const id = m[1];
                const rawLabel = m[2] ?? id;
                ensure(id, rawLabel, SHAPE_MAP[k], k);
                const grp = groups.find((g) => g.id === stack[stack.length - 1]);
                if (grp)
                    grp.members.push(id);
                break;
            }
        }
    }
    return {
        type,
        nodes: Array.from(nodes.values()),
        edges,
        groups,
        styles: {},
        meta: {},
    };
};
//# sourceMappingURL=c4.js.map